<template>
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">E-mail</th>
        <th scope="col" class="border-0">Responsável</th>
        <th scope="col" class="border-0">UF</th>
        <th scope="col" class="text-center border-0">Indicações 30d</th>
        <th scope="col" class="border-0">Venda direta</th>
        <th scope="col" class="border-0">Ativo</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in distributors" :key="index">
        <td class="td-1">{{ row.id }}</td>
        <td class="td-2 link">
          <router-link
            :to="{
              name: 'admin-distributor-edit',
              params: { id: row.id },
            }"
          >
            {{ row.name }}
          </router-link>
        </td>
        <td class="td-2">{{ row.email }}</td>
        <td class="td-2">{{ row.responsible }}</td>
        <td class="td-1">{{ row.uf }}</td>
        <td class="td-2 text-center">{{ row.leads_count }}</td>
        <td class="td-1">
          <d-checkbox
            toggle
            @change="onToggleDirectSales(row)"
            :checked="row.direct_sales == 1"
            class="custom-toggle-sm d-inline-flex m-1"
          />
        </td>
        <td class="td-1">
          <d-checkbox
            toggle
            @change="toggleStatus(row)"
            :checked="row.status == 1"
            class="custom-toggle-sm d-inline-flex m-1"
          />
        </td>
        <td class="td-2">
          <distributor-buttons :distributor="row" />
        </td>
      </tr>
      <tr v-if="distributors.length === 0">
        <td colspan="9" class="no-content">
          Ainda não tem nenhum distribuidor cadastrado.
        </td>
      </tr>
    </tbody>
    <distributor-imports />
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import DistributorButtons from './DistributorButtons.vue';
import DistributorImports from './DistributorImports.vue';
import DistributorActions from './DistributorActions';

export default {
  name: 'distributor-table',
  mixins: [DistributorActions],
  components: {
    DistributorButtons,
    DistributorImports,
  },
  props: {
    distributors: {
      type: Array,
    },
  },
  methods: {
    ...mapActions(['setToggle']),
    toggleStatus(row) {
      this.blockAccess(row);
    },
    onToggleDirectSales(row) {
      this.toggleDirectSales(row);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';
.td {
  &-1 {
    max-width: 60px;
  }
  &-2 {
    min-width: 140px;
    max-width: 300px;
  }
}
</style>
